export default "__VITE_ASSET__Bx1nOLMM__"